"use strict";

exports.__esModule = true;
exports.rpx2px = exports.px2rpx = void 0;

var _universalDevice = require("universal-device");

var CALCULATION_ACCURACY = 8;

var px2rpx = function (value) {
  return Number((750 * value / _universalDevice.screenWidth).toFixed(CALCULATION_ACCURACY));
};

exports.px2rpx = px2rpx;

var rpx2px = function (value) {
  return Number((_universalDevice.screenWidth / 750 * value).toFixed(CALCULATION_ACCURACY));
};

exports.rpx2px = rpx2px;